import bgMusic from "./assets/bg_music.mp3";
import wheelSound from "./assets/tick.mp3";
import { loadSound } from "./utils/sound";

export const tickSound = loadSound(wheelSound);
export const bgSound = loadSound(bgMusic);
